import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MarkantElementsModule } from '@markant/elements-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { UiCardComponent } from '@markant-platform/shared/ui-card';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'markant-platform-usage-report-tile',
  standalone: true,
  imports: [MarkantElementsModule, TranslocoModule, UiCardComponent, RouterLink],
  templateUrl: './usage-report-tile.component.html',
  styleUrl: './usage-report-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UsageReportTileComponent {
  @Input({ required: true }) variantName!: string;
  @Input() link: string[] = ['usages'];
}
